import {
	ChangeDetectionStrategy,
	Component,
	Input,
} from '@angular/core';

import { ApplicationErrors } from 'ib/internetbank-core/ib-exceptions/ib-exceptions';

import { ChargeForWidget } from '../charge-item/change-item-entites';


@Component({
	selector: 'app-charge-list',
	templateUrl: './charge-list.component.html',
	styleUrls: ['./charge-list.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class ChargeListComponent {

	@Input()
	public items: Array<ChargeForWidget>;

	@Input()
	public errors: ApplicationErrors | null;

	@Input()
	public onSearchTab: boolean;

	@Input()
	public searchDocNumber: string | undefined;

	public readonly defaultLimitTo: number = 2;


	public limitTo: number = this.defaultLimitTo;

	public get limitToLabel(): string | undefined {
		if (this.items.length > this.limitTo) {
			return `Смотреть все (${this.items.length})`;
		} else if (this.limitTo === this.items.length) {
			return 'Свернуть';
		}
	}

	public isVisibleToggleLimitTo(): boolean {
		return this.items && this.items.length > this.defaultLimitTo;
	}

	public toggleLimitTo(): void {
		if (this.items.length > this.limitTo) {
			this.limitTo = this.items.length;
		} else if (this.limitTo === this.items.length) {
			this.limitTo = this.defaultLimitTo;
		}
	}
}
